import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import api, { formatApiError } from "../lib/api";

export function WorkerCredentialsDialog({ worker, onClose, onDone }) {
  const [userId, setUserId] = useState(worker?.user_id || "");
  const [email, setEmail] = useState(worker?.email || "");
  const [password, setPassword] = useState("");
  useEffect(() => {
    setUserId(worker?.user_id || "");
    setEmail(worker?.email || "");
    setPassword("");
  }, [worker?.email, worker?.id, worker?.user_id]);
  const submit = async (event) => {
    event.preventDefault();
    try {
      await api.put(`/team/${worker.id}/credentials`, {
        user_id: userId,
        email: email || null,
        new_password: password || null,
      });
      toast.success("Worker User ID updated");
      onDone();
      onClose();
    } catch (error) { toast.error(formatApiError(error)); }
  };
  return <Dialog open={Boolean(worker)} onOpenChange={(open) => !open && onClose()}><DialogContent data-testid="worker-credentials-dialog"><DialogHeader><DialogTitle>{worker ? `Edit User ID — ${worker.name}` : "Edit User ID"}</DialogTitle></DialogHeader><form className="dialog-form" onSubmit={submit}><Label htmlFor="worker-user-id">User ID</Label><Input id="worker-user-id" data-testid="worker-user-id-input" value={userId} onChange={(event) => setUserId(event.target.value)} required /><Label htmlFor="worker-login-email">Contact Email (Optional)</Label><Input id="worker-login-email" data-testid="worker-login-email-input" type="email" value={email} onChange={(event) => setEmail(event.target.value)} /><Label htmlFor="worker-new-password">New Password</Label><Input id="worker-new-password" data-testid="worker-new-password-input" type="password" minLength={8} value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Leave blank to keep current password" /><Button type="submit" data-testid="save-worker-credentials-button">Save User ID Details</Button></form></DialogContent></Dialog>;
}

export function SelfPasswordDialog({ open, onClose }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    try {
      await api.post("/auth/change-password", { current_password: currentPassword, new_password: newPassword });
      toast.success("Password updated");
      setCurrentPassword("");
      setNewPassword("");
      onClose();
    } catch (error) { toast.error(formatApiError(error)); }
  };
  return <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}><DialogContent data-testid="self-password-dialog"><DialogHeader><DialogTitle>Change My Password</DialogTitle></DialogHeader><form className="dialog-form" onSubmit={submit}><Label htmlFor="current-password">Current Password</Label><Input id="current-password" data-testid="current-password-input" type="password" minLength={8} value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} required /><Label htmlFor="new-password">New Password</Label><Input id="new-password" data-testid="new-password-input" type="password" minLength={8} value={newPassword} onChange={(event) => setNewPassword(event.target.value)} required /><Button type="submit" data-testid="save-self-password-button">Update Password</Button></form></DialogContent></Dialog>;
}